import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { LocationsController } from "../../controllers/LocationsController"

export type TScene = "fight" |
    "dialog" |
    "create" |
    "main" |
    "Locations" |
    "explore" |
    "shop" |
    "chest" |
    "camp" |
    "campAllies" |
    "campCharacterUpgrade" |
    "campEquipmentUpgrade"

export interface IinitialState {
    scene: TScene,
    locations: LocationsController,
    // locationsIndex: number,
    currentLocation: number,
    passsedLocationLevels: number
}

const initialState: IinitialState = {
    scene: "create",
    locations: LocationsController.getInstance(),
    // locationsIndex: 0,
    currentLocation: 0,
    passsedLocationLevels: 0,
}

export const sceneSlice = createSlice({
    name: "scene",
    initialState,
    reducers: {
        setScene(state, action: PayloadAction<TScene>) {
            state.scene = action.payload
        },
        // setLocations(state, action: PayloadAction<Location[][]>) {
        //     state.locations = action.payload
        // },
        setCurrentLocation(state, action: PayloadAction<number>) {
            state.currentLocation = action.payload
        },
        // changeCurrentLocation(state, action: PayloadAction<Location[]>) {
        //     state.locations[state.currentLocation] = action.payload
        // },
        // resetLocations(state, action: PayloadAction<Location[][]>) {
        //     state.locations = action.payload
        // },
        setPasssedLocationLevels(state, action: PayloadAction<number>) {
            state.passsedLocationLevels = state.passsedLocationLevels + action.payload
        },
        resetPassedLocationLevels(state, action: PayloadAction<number>) {
            state.passsedLocationLevels = action.payload
        },
    }
})

export default sceneSlice.reducer